export const INIT_FLIGHT_RESERVATIONS = "INIT_FLIGHT_RESERVATIONS";
export const INIT_FLIGHT_RESERVATION = "INIT_FLIGHT_RESERVATION";
